var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpecialOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.37,
    height: 22.25,
    viewBox: "0 0 25.37 22.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26276",
    "data-name": "Group 26276",
    transform: "translate(-0.165 -1.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26276-2",
    "data-name": "Group 26276",
    transform: "translate(1.226 3.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36905",
    "data-name": "Path 36905",
    d: "M1.406,10.573,13.766,22.93l7.388-7.39L8.8,3.185H1.407Z",
    transform: "translate(-1.406 -3.185)",
    fill: "#ffb299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36907",
    "data-name": "Path 36907",
    d: "M6.47,6.823a1.415,1.415,0,0,0,0,2.83,1.463,1.463,0,0,0,1-.416,1.415,1.415,0,0,0-1-2.416h0Z",
    transform: "translate(-1.935 -3.712)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26276-3",
    "data-name": "Group 26276",
    transform: "translate(0.165 1.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36757",
    "data-name": "Path 36757",
    d: "M8.859,2.544l-.275.275L21.2,15.431,13.608,23.02l-12.5-12.5V2.931H8.859V2.542l-.275.275.275-.275V2.153H.331v8.69L13.608,24.12l8.69-8.69L9.021,2.153H8.859Z",
    transform: "translate(-0.189 -2.014)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36905-2",
    "data-name": "Path 36905",
    d: "M13.584,24.24a.145.145,0,0,1-.1-.041L.207,10.925a.145.145,0,0,1-.042-.1V2.131A.142.142,0,0,1,.307,1.99H9a.134.134,0,0,1,.1.041L22.373,15.308a.141.141,0,0,1,0,.2l0,0L13.684,24.2A.149.149,0,0,1,13.584,24.24ZM.448,10.763,13.584,23.9l8.489-8.49L8.978,2.314V2.52a.165.165,0,0,1,0,.029v.359a.142.142,0,0,1-.022.077L21.277,15.306a.142.142,0,0,1,0,.2L13.688,23.1a.141.141,0,0,1-.2,0L.987,10.6a.142.142,0,0,1-.042-.1V2.907a.141.141,0,0,1,.141-.141H8.422a.152.152,0,0,1,.039-.073L8.7,2.46V2.271H.45Zm.778-.323L13.586,22.8l7.388-7.39L8.618,3.052H1.227Z",
    transform: "translate(-0.165 -1.99)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36758",
    "data-name": "Path 36758",
    d: "M13.629,2.84,26.242,15.453l-7.867,7.867.55.551,8.414-8.414L14.177,2.294l-.551.551Z",
    transform: "translate(-2.116 -2.034)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36906",
    "data-name": "Path 36906",
    d: "M18.9,23.985a.141.141,0,0,1-.1-.041l-.551-.551a.143.143,0,0,1,0-.2l7.764-7.764L13.507,2.918a.142.142,0,0,1,0-.2l.551-.549a.14.14,0,0,1,.2,0l0,0L27.421,15.329a.141.141,0,0,1,.041.1.138.138,0,0,1-.041.1l-8.415,8.415A.14.14,0,0,1,18.9,23.985Zm-.349-.693.349.351,8.214-8.214L14.156,2.468l-.349.349L26.319,15.329a.142.142,0,0,1,0,.2Z",
    transform: "translate(-2.093 -2.01)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36759",
    "data-name": "Path 36759",
    d: "M6.314,6.186v.389a1.557,1.557,0,1,1-1.1.457,1.558,1.558,0,0,1,1.1-.457V5.8A2.336,2.336,0,1,0,8.65,8.133h0A2.336,2.336,0,0,0,6.314,5.8Z",
    transform: "translate(-0.718 -2.542)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36907-2",
    "data-name": "Path 36907",
    d: "M6.292,10.587a2.48,2.48,0,0,1,0-4.959h0a2.48,2.48,0,0,1,.01,4.959ZM6.15,5.92a2.195,2.195,0,1,0,.283,0v.5a1.7,1.7,0,0,1-.141,3.392h0a1.7,1.7,0,0,1-.138-3.39Zm.14.77a1.415,1.415,0,0,0,0,2.83,1.471,1.471,0,0,0,1-.416,1.415,1.415,0,0,0-1-2.416h0Z",
    transform: "translate(-0.694 -2.517)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpecialOffer);
export default __webpack_public_path__ + "static/media/icon-special-offer.1b6f59cfde4c9b984ed0ced7a06ed99a.svg";
export { ForwardRef as ReactComponent };